"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
const react_1 = __importDefault(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../../util");
function Breadcrumbs(props) {
    const { items } = props;
    return (react_1.default.createElement("div", { className: "glx-default-text glx-flex-r glx-flex-g-4" }, items.map((e, index) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, util_1.cnx)([!!e.action, 'glx-underline glx-pointer']), onClick: () => {
                e.action?.();
            } }, e.name),
        ' ',
        index < items.length - 1 ? (react_1.default.createElement("div", null,
            react_1.default.createElement(react_icons_1.IOChevronForward, null))) : null)))));
}
exports.Breadcrumbs = Breadcrumbs;
